import { useEffect } from "react";
import { Socket } from "socket.io-client";
import { SOCKET_EVENTS } from "constants/socketEvents";

// Input that means a person is actually using the app. Plain page views,
// polling and auto-refresh don't count — the server already knows the tab is
// open from the socket itself.
const ACTIVITY_EVENTS = [
  "pointerdown",
  "pointermove",
  "keydown",
  "wheel",
  "touchstart",
];
const MIN_GAP_MS = 60 * 1000;

/**
 * Tells the server "someone is using this tab" at most once a minute, and only
 * while the tab is visible. Feeds the user's "last active" time.
 */
const useActivityHeartbeat = (socket: Socket | null) => {
  useEffect(() => {
    if (!socket) return;
    let lastSent = 0;

    const onActivity = () => {
      const now = Date.now();
      if (now - lastSent < MIN_GAP_MS) return;
      if (document.visibilityState !== "visible" || !socket.connected) return;
      lastSent = now;
      socket.emit(SOCKET_EVENTS.PRESENCE.ACTIVE);
    };

    const options = { passive: true, capture: true };
    ACTIVITY_EVENTS.forEach((e) =>
      window.addEventListener(e, onActivity, options),
    );
    return () => {
      ACTIVITY_EVENTS.forEach((e) =>
        window.removeEventListener(e, onActivity, options),
      );
    };
  }, [socket]);
};

export default useActivityHeartbeat;
